import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useEmailEntradaBorderoDispatch, useEmailEntradaBorderoSelector } from '../../store/EmailEntradaBordero/EmailEntradaBorderoProvider';
import LoadingUI from '../../components/UI/Loading/LoadingUI';
import useStyles, {
  ButtonEnviar, Buttons, ContainerPrincipal, TitleTable,
} from './EmailEntradaBorderoStyles';
import { getNewPage } from '../../helpers';
import { emailEntradaBorderoFactory } from './EmailEntradaBorderoFactory';
import { setSimpleEmailEntradaBorderoAction, setSimpleValuesListIdsAction } from '../../store/EmailEntradaBordero/EmailEntradaBordero.store';
import { buscarDadosTabelaAction, enviarEmailEntradaBorderoAction, excluirEmailEntradaBorderoAction } from '../../store/EmailEntradaBordero/EmailEntradaBordero.saga';
import TabelaEmailEntradaBordero from './TabelaEmailEntradaBordero';
import OptionDialogNew from '../../components/UI/Dialogs/OptionDialog/OptionDialogNew';
import DialogNew from '../../layouts/FormDialog/DialogNew';
import { DialogEditarDadosDevedor } from './DialogEditarDadosDevedor/DialogEditarDadosDevedor';


function EmailEntradaBorderoComponent() {
  const dispatch = useEmailEntradaBorderoDispatch();
  const styles = useStyles();

  const page = useEmailEntradaBorderoSelector(states => states.page);
  const rowsPerPage = useEmailEntradaBorderoSelector(states => states.rowsPerPage);
  const totalElements = useEmailEntradaBorderoSelector(states => states.totalElements);
  const tableView = useEmailEntradaBorderoSelector(states => states.tableView);
  const loadingPage = useEmailEntradaBorderoSelector(states => states.common.loadingPage);
  const selectAll = useEmailEntradaBorderoSelector(states => states.selectAll);
  const listIds = useEmailEntradaBorderoSelector(states => states.listIds);
  const nenhumSelecionado = !Object.values(listIds).some(Boolean);
  const [conteudoTabela, setConteudoTabela] = useState([]);
  const [idEmailEntradaBorderoDelete, setIdEmailEntradaBorderoDelete] = useState();
  const [idEmailEntradaBorderoEdit, setIdEmailEntradaBorderoEdit] = useState();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);

  const changeRowsPerPageHandler = useCallback((e) => {
    const size = e.target.value;
    const newPage = getNewPage(rowsPerPage, page, size);

    dispatch(setSimpleEmailEntradaBorderoAction('page', Number(newPage)));
    dispatch(setSimpleEmailEntradaBorderoAction('rowsPerPage', Number(size)));
    dispatch(setSimpleEmailEntradaBorderoAction('tableView', tableView));
    dispatch(buscarDadosTabelaAction(false));
  }, [dispatch, rowsPerPage, page, tableView]);

  const changePageHandler = useCallback((event, newPage) => {
    dispatch(setSimpleEmailEntradaBorderoAction('page', Number(newPage)));
    dispatch(setSimpleEmailEntradaBorderoAction('tableView', tableView));
    dispatch(buscarDadosTabelaAction(false));
  }, [dispatch, tableView]);

  const changeSelectAll = useCallback((e) => {
    const { checked } = e.target;
    dispatch(setSimpleEmailEntradaBorderoAction('selectAll', checked));
    dispatch(setSimpleEmailEntradaBorderoAction(
      'listIds',
      Object.fromEntries(Object.keys(listIds).map(key => [key, checked])),
    ));
  }, [dispatch, listIds]);

  const changeSelectId = useCallback((e) => {
    const { name, checked } = e.target;
    dispatch(setSimpleValuesListIdsAction(name, checked));
  }, [dispatch]);

  const onClickEnviar = useCallback(() => {
    const ids = Object.keys(listIds).filter(k => listIds[k]).map(Number);
    dispatch(enviarEmailEntradaBorderoAction(ids));
  }, [dispatch, listIds]);

  const handlerExcluirEmailEntradaBordero = useCallback((idEmailEntradaBordero) => {
    setIdEmailEntradaBorderoDelete(idEmailEntradaBordero);
    setOpenDeleteDialog(true);
  }, []);

  const handlerEditarEmailEntradaBordero = useCallback((idEmailEntradaBordero) => {
    setIdEmailEntradaBorderoEdit(idEmailEntradaBordero);
    setOpenEditDialog(true);
  }, []);

  const onClickConfirmDelete = useCallback(() => {
    dispatch(excluirEmailEntradaBorderoAction(idEmailEntradaBorderoDelete));
    setOpenDeleteDialog(false);
  }, [idEmailEntradaBorderoDelete, dispatch]);

  useEffect(() => {
    dispatch(buscarDadosTabelaAction());
  }, [dispatch]);

  useEffect(() => {
    setConteudoTabela(emailEntradaBorderoFactory.makeConteudoTabela(
      tableView,
      handlerExcluirEmailEntradaBordero,
      handlerEditarEmailEntradaBordero,
      listIds,
      changeSelectId,
    ));
  }, [tableView, handlerExcluirEmailEntradaBordero, handlerEditarEmailEntradaBordero, listIds, changeSelectId]);

  return (
    <>
      <DialogNew
        className={styles.dialogEditarDadosDevedor}
        open={openEditDialog}
        text="Editar Dados de Devedor"
      >
        {openEditDialog && (
          <DialogEditarDadosDevedor
            setOpenEditDialog={setOpenEditDialog}
            idEmailEntradaBordero={idEmailEntradaBorderoEdit}
          />
        )}
      </DialogNew>
      <OptionDialogNew
        open={openDeleteDialog}
        confirmLabel="Confirmar"
        cancelLabel="Cancelar"
        onClickCancel={() => { setOpenDeleteDialog(false); }}
        onClickConfirm={() => onClickConfirmDelete()}
        text="Deseja excluir este processo da lista de envio do Email de Entrada de Borderô?"
      />
      <LoadingUI show={loadingPage} />
      <ContainerPrincipal>
        <Buttons>
          <ButtonEnviar
            onClick={onClickEnviar}
            disabled={nenhumSelecionado}
          >
            Enviar
          </ButtonEnviar>
        </Buttons>
        <TitleTable>
          Processos Aguardando Envio de Email de Entrada de Borderô
        </TitleTable>
        <TabelaEmailEntradaBordero
          columns={emailEntradaBorderoFactory.makeCabecalhoTabela(selectAll, changeSelectAll)}
          rows={conteudoTabela}
          page={page}
          size={totalElements}
          rowsPerPageOptions={[10, 15, 20]}
          rowsPerPage={rowsPerPage}
          onChangePage={changePageHandler}
          onChangeRowsPerPage={changeRowsPerPageHandler}
        />
      </ContainerPrincipal>
    </>
  );
}

export const EmailEntradaBordero = withRouter(EmailEntradaBorderoComponent);
